<script lang="ts">
  import { inview } from 'svelte-inview';

  import { cn } from '@shared/utils';

  import Loader from './loader.svelte';

  export let loading = false;
  export let loadMoreFunction: () => Promise<void>;

  export let isLoadMoreEnabled = false;

  async function loadMoreHandler() {
    loading = true;
    await loadMoreFunction();
    loading = false;
  }
</script>

<section
  class="{cn(
    'relative after:pointer-events-none after:absolute after:bottom-10 after:left-0 after:right-0 after:top-0 after:block after:w-full after:opacity-0',
    {
      'after:bg-whitish after:pointer-events-auto after:opacity-100 after:backdrop-blur-[1px]': loading,
    },
  )}"
>
  <slot />

  <div class="{cn('invisible', { visible: loading })}">
    <Loader />
  </div>

  {#if isLoadMoreEnabled && !loading}
    <div
      use:inview="{{ rootMargin: '100px' }}"
      on:inview_enter="{() => {
        loadMoreHandler();
      }}"
      class="absolute bottom-0"
    ></div>
  {/if}
</section>
